// IE 2026 10 12 / ODOO-5800 (чипс «Mine» / «Мої» / «Мои» грида сигналов; правило Игоря: заголовки предопределённого — на трёх языках): подпись чипса на языке
// пользователя. Чипсы, которые кладёт конфигурация (CHIP-Where «Active», «Resolved», «Mine»…), несут title (английский) и title_uk / title_ru; раньше чипс
// показывал только title. У en суффикса нет; у CHIP-Search title — текст поиска (переводов не бывает). Флаг fe.ux.chipTitleLang (дефолт ВКЛ); выкл — title.
// Чистая логика — юнит tests/unit/chipTitleLang.test.mjs
export const CHIP_TITLE_LANG_FLAG = 'fe.ux.chipTitleLang'
export const CHIP_LANG_DEFAULT = 'en'

export function chipTitleLang_on(setting) {
    try { return typeof setting === 'function' ? setting(CHIP_TITLE_LANG_FLAG, true) !== false : true } catch (e) { return true }
}

// подпись чипса на языке lang: title_<lang>, если есть и чипс не поиск; иначе title
export function chip_titleLang(chip, lang) {
    if (!chip || typeof chip !== 'object') return ''
    const raw = ('_raw' in chip && chip._raw && typeof chip._raw === 'object') ? chip._raw : chip
    const L = String(lang || '').toLowerCase()
    if (L && L !== CHIP_LANG_DEFAULT && (raw.segment || chip.segment) !== 'CHIP-Search') {
        const v = raw['title_' + L] ?? chip['title_' + L]
        if (typeof v === 'string' && v.trim()) return v
    }
    return chip.title
}
